var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningNoBorder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 6.95871C12.25 6.01362 13.0333 5.25 13.9988 5.25C14.9655 5.25 15.75 6.01362 15.75 6.95871C15.75 15.9218 13.9988 17.3654 13.9988 17.3654C13.9988 17.3654 12.25 15.9218 12.25 6.95871ZM12.25 21.0006C12.25 20.0336 13.0333 19.25 13.9988 19.25C14.9655 19.25 15.75 20.0336 15.75 21.0006C15.75 21.9664 14.9655 22.75 13.9988 22.75C13.0333 22.75 12.25 21.9664 12.25 21.0006Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningNoBorder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WarningNoBorder.2629c542162169768164e7f5c6591303.svg";